module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ClanInfoPanel/images/pattern-right.214deea4.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ClanInfoPanel/images/pattern-right.jpg
// module id = 3268
// module chunks = 11